import { render, staticRenderFns } from "./StatsPlugin.vue?vue&type=template&id=e3308752&scoped=true"
import script from "./StatsPlugin.vue?vue&type=script&lang=ts"
export * from "./StatsPlugin.vue?vue&type=script&lang=ts"
import style0 from "./StatsPlugin.vue?vue&type=style&index=0&id=e3308752&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3308752",
  null
  
)

export default component.exports